import React, { useState } from 'react'
import { apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/pathObj'
import { useForm } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import OInputField from 'components/reusable/OInputField'
import { useTranslation } from 'react-i18next'
import ErrorMessage from 'components/ErrorMessage'
import { validationRules } from '../../utils/constants'
import { preventMax } from '../../utils/validations'

const InitiateRefund = ({ setShowRefundModal, getRefundList }) => {
  const { t } = useTranslation()

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {}
  })

  const notification = useToastContext()
  const [addOfferLoading, setAddOfferLoading] = useState(false)

  const handleSubmitForm = async data => {
    try {
      const body = {
        username: data.username,
        transactionId: data.transactionId,
        amount: data.amount,
        reason: data.reason
      }
      const res = await apiPost(apiPath.initiateRefund, body)
      if (res.data.success === true) {
        setShowRefundModal(false)
        notification.success(res.data.message)
      } else {
        notification.error(res.data.message)
      }
    } catch (err) {
      console.log('err:', err)
    } finally {
      setAddOfferLoading(false)
      getRefundList()
    }
  }

  const preventMaxValueDescription = e => {
    e.target.value = e.target.value.trimStart()
    e.target.value = e.target.value.replace(/  +/g, ' ')
    if (e.target.value.length > 200) {
      e.target.value = e.target.value.slice(0, 200)
    }
  }
  const preventMaxValueID = e => {
    e.target.value = e.target.value.trimStart()
    e.target.value = e.target.value.replace(/  +/g, ' ')
  }
  const handleAmount = e => {
    var value = e.target.value
    const pattern = /^\d{0,5}(\.\d{0,2})?$/
    if (e.target.value === '') {
      e.target.value = e.target.value.slice(e.target.value?.length - 1, -1)
    }
    const isValid = pattern.test(value)
    if (!isValid) {
      value = value.slice(0, -1)
    }
    setValue('amount', value)
  }
  var pressedKeys = []

  return (
    <div>
      <div
        id='add-offer'
        className='fixed  pt-16 z-40 h-screen px-6 pb-4 overflow-y-auto bg-white sm:w-96 w-80 right-0 top-0 '
        aria-labelledby='drawer-label'
      >
        <div>
          <button
            onClick={() => setShowRefundModal(false)}
            title={t('O_CLOSE')}
            type='button'
            data-drawer-hide='drawer-example'
            aria-controls='drawer-example'
            className='text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 right-2.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white'
          >
            <img src='./images/close-circle.png' alt='close' />

            <span className='sr-only'>{t('CLOSE_MENU')}</span>
          </button>
        </div>
        <h3 className='font-medium text-[18px] mb-4'>
          {t('INITIATE_NEW_REFUND')}
        </h3>
        <form>
          <div className='flex my-5 gap-4'>
            <div className='relative w-full '>
              <OInputField
                name="username"
                inputLabel={
                  <>
                    {t("O_USERNAME")}
                    <span className="text-red-500">*</span>
                  </>
                }
                errors={errors}
                type="text"
                onKeyDown={(e) => {
                  if ([" "].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                register={register("username", {
                  required: t("PLEASE_ENTER_USERNAME"),
                  minLength: {
                    value: 1,
                    message: t("PLEASE_ENTER_USERNAME"),
                  },
                })}
              />
            </div>
          </div>

          <div className='relative  my-5'>
            <OInputField
              name='transactionId'
              inputLabel={
                <>
                  {t('REFUND_TRANSACTION_ID')}
                  <span className='text-red-500'>*</span>
                </>
              }
              errors={errors}
              type='text'
              onInput={e => preventMaxValueID(e)}
              register={register('transactionId', {
                required: t('PLEASE_ENTER_TRANSACTION_ID')
              })}
            />
          </div>

          <div className='relative  my-5'>
            <OInputField
              name='amount'
              inputLabel={
                <>
                  {t('REFUND_AMOUNT')}
                  <span className='text-red-500'>*</span>
                </>
              }
              errors={errors}
              type='number'
              step='any'
              register={register('amount', {
                required: t('PLEASE_ENTER_AMOUNT'),
                onChange: e => handleAmount(e),
                validate: value => {
                  return value !== '0'
                    ? true
                    : t('VALUE_CAN_NOT_BE_LESS_THAN_0.01')
                }
              })}
              onKeyDown={e => {
                pressedKeys.push(e.key)
                var lastKey = pressedKeys[pressedKeys.length - 2]
                if (lastKey === '.') {
                  if (['-', '.', '+', 'e'].includes(e.key)) {
                    e.preventDefault()
                  }
                } else if (['-', '+', 'e'].includes(e.key)) {
                  e.preventDefault()
                }
              }}
            />
          </div>
          <div className='relative  my-5'>
            <textarea
              name='reason'
              rows='4'
              id='reason'
              className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none focus:border-blue-500 focus:outline-none focus:ring-0  peer'
              placeholder=' '
              maxLength={200}
              onInput={e => preventMaxValueDescription(e)}
              {...register('reason', {
                required: t('PLEASE_ENTER_REASON'),
                minLength: {
                  value: 10,
                  message: t('MINIMUM_LENGTH_MUST_BE_10')
                },
                maxLength: {
                  value: 200,
                  message: t('MAXIMUM_CHARACTER_CAN_BE_200')
                },
                validate: value => {
                  return !!value?.trim() ? true : t('WHITE_SPACE_NOT_ALLOWED')
                }
              })}
            />
            <label
              htmlFor='reason'
              className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] duration-300 transform -translate-y-6 bg-white scale-75 top-3 left-3 p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
            >
              {t('REFUND_REASON')}
              <span className='text-red-500'>*</span>
            </label>
            <ErrorMessage message={errors?.reason?.message} />
          </div>

          <button
            class='bg-LightBlue hover:bg-DarkBlue cursor-pointer   text-white  font-medium  w-full active:bg-slate-100 text-sm px-8 py-4 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none  ease-linear transition-all duration-150 undefined'
            type='submit'
            onClick={handleSubmit(handleSubmitForm)}
          >
            {addOfferLoading ? 'Loading...' : <>{t('O_ADD')}</>}
          </button>
        </form>
      </div>
      <div class='bg-gray-900  bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-30 overlay' />
    </div>
  )
}

export default InitiateRefund
